module.exports = __webpack_public_path__ + "img/btn_xiankuang.6a69fa52.png";